<template>
    <x-page title="Group Role">
        <template #header-actions>
            <x-create-button url="/admin/group-roles/create" 
                :disabled="isLoading"
                v-if="can('createGroupRoles')" />
        </template>

        <x-filter-box :onFilter="handleFilter"
            :onReset="resetFilter">
            <div class="row">
                <div class="col-xs-12 col-md-6">
                    <x-form-group label="Label">
                        <input class="form-control"
                            type="text"
                            v-model="filters.search"
                            @keyup.enter="() => handleFilter()"
                            placeholder="Masukkan label role" />
                    </x-form-group>
                </div>
            </div>
        </x-filter-box>

        <x-table :headers="[
            '#',
            'Label',
            '',
        ]" :is-loading="isLoading">
            <tr v-for="(resource, index) in resources" :key="index">
                <td>{{ rowIndex(index, $route.query) }}</td>
                <td class="nowrap">
                    <router-link :to="`/admin/group-roles/${resource.id}`" 
                        title="Klik untuk lihat detail">
                        {{ resource.label }}
                    </router-link>
                </td>
                <td>
                    <x-quick-edit-button :url="`/admin/group-roles/${resource.id}/edit`"
                        :disabled="isLoading" v-if="can('updateGroupRoles')" />
                    <x-quick-delete-button @click="deleteResource(resource)"
                        :disabled="isLoading" v-if="can('deleteGroupRoles')" />
                </td>
            </tr>
        </x-table>

        <x-pagination v-if="shouldRenderPagination" :pagination="meta" />
    </x-page>
</template>

<script>
import XAjaxDropdown from '../../components/XAjaxDropdown.vue'
import XCreateButton from '../../components/XCreateButton.vue'
import XQuickDeleteButton from '../../components/XQuickDeleteButton.vue'
import XQuickEditButton from '../../components/XQuickEditButton.vue'
import XFilterBox from '../../components/XFilterBox.vue'
import XFormGroup from '../../components/XFormGroup.vue'
import XPage from '../../components/XPage.vue'
import XTable from '../../components/XTable.vue'
import { deletePrompt, handleGeneralXhrError } from '../../helpers'
import FilterableMixin from '../../mixins/FilterableMixin'
import PaginationMixin from '../../mixins/PaginationMixin'
import PermissionMixin from '../../mixins/PermissionMixin'

const defaultFilters = {
    search: null,
}

export default {
    beforeRouteUpdate(to, from, next) {
		this.fetchResources(to)
		next()
	},
    components: {
        XCreateButton,
        XTable,
        XQuickEditButton,
        XQuickDeleteButton,
        XPage,
        XFormGroup,
        XFilterBox,
        XAjaxDropdown,
    },
    created() {
        this.preselectFilters(defaultFilters)
        this.handleFilter().catch(() => {
            this.fetchResources()
        })
    },
    data() {
        return {
            filters: { ...defaultFilters },
            isLoading: false,
            resources: [],
        }
    },
    methods: {
        deleteResource(resource) {
            deletePrompt({
                name: resource.label,
                onConfirm: () => {
                    this.isLoading = true
                    const request = axios.delete(`/api/group-roles/${resource.id}`)
                        .then(() => {
                            this.$notify({
                                type: 'success',
                                title: `Berhasil`,
                                text: `${resource.label} dihapus!`,
                            })
                            this.fetchResources()
                        })
                    handleGeneralXhrError(request).finally(() => {
                        this.isLoading = false
                    })
                },
            })
        },
        fetchResources(route = this.$route) {
            this.isLoading = true
            const request = axios.get('/api/group-roles', {
                params: route.query
            })
            .then(response => {
                this.resources = response.data.data
                this.setMeta(response)
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        handleFilter() {
            return this.$router.push({
                path: this.$route.path,
                query: _.pickBy({
                    ...this.filters,
                    page: 1,
                    without_global_scopes: 1,
                }),
            })
        },
        resetFilter() {
            this.filters = { ...defaultFilters }
            this.handleFilter()
        },
    },
    mixins: [
        FilterableMixin,
        PaginationMixin,
        PermissionMixin,
    ],
}
</script>